import { render } from "./page-loader.vue?vue&type=template&id=3e6d21b2&scoped=true"
import script from "./page-loader.vue?vue&type=script&lang=js"
export * from "./page-loader.vue?vue&type=script&lang=js"

import "./page-loader.vue?vue&type=style&index=0&id=3e6d21b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6d21b2"]])

export default __exports__